import axios from "../api/axios";
import { apiURL } from "../config";

const login = async (username, password) => {
	if (username && password) {
		return axios
			.post(`${apiURL}/user/login.json`, JSON.stringify({ username, password }))
			.then((response) => {
				if (response.status === 200 && response.data.token) {
					localStorage.setItem("user", JSON.stringify({ ...response.data, date: new Date() }));
					return response;
				}
			})
			.catch((err) => {
				return err.response.data;
			});
	}
};

const logout = () => {
	localStorage.removeItem("user");
	location.reload();
};

const AuthService = {
	login,
	logout,
};
export default AuthService;
